import uuid from 'uuid-random';

export const QUESTIONNAIRE_POPUP_ID = uuid();

export const DEFAULT_QUESTIONNAIRE_FORM = 'QUESTIONNAIRE';

export const DEPOSIT_LIMIT_UNLIMITED_VALUE_STR = '9223372036854775807';
